var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.58167V11.5976C12 11.8203 11.8193 12 11.5977 12H7.55176V11.0605H11.0625C11.0625 9.85529 11.0625 8.78782 11.0625 7.58167H12ZM7.55762 0.93074V0H11.5977C11.8203 0 12 0.180679 12 0.402376V4.42419H11.0596V0.93074H7.55762ZM0.94043 4.41833H0V0.402376C0 0.180679 0.180664 0 0.402344 0H4.40625V0.941483H0.94043V4.41833ZM4.40137 11.0624V12H0.402344C0.179687 12 0 11.8193 0 11.5966V7.57581H0.94043V11.0634H4.40137V11.0624Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon3);
export default __webpack_public_path__ + "static/media/expand-icon-3.800fa2c60ad7c196d40ae24f913102ed.svg";
export { ForwardRef as ReactComponent };